<ng-container>
  <mat-toolbar style="display: flex; justify-content: space-between">
    <div class="title">
      Edit Change Request <span *ngIf="updateNotice()?.name">: {{ updateNotice()?.name }}</span>
    </div>
    <div class="btn-actions">
      @if (!isPublishedOrCancelled() && !loaders()?.getUpdateNotice) {
        <!-- Save Changes button -->
        <button
          color="primary"
          *ngIf="hasAssignee() && isInEdit()"
          mat-icon-button
          [disabled]="!ableToSave()"
          (click)="saveChanges()">
          <mat-icon>save</mat-icon>
        </button>
        <!-- Delete Update Notice button -->
        <button
          mat-icon-button
          *ngIf="hasAssignee() && isInEdit()"
          (click)="deleteUpdateNotice()">
          <mat-icon color="warn">delete</mat-icon>
        </button>
        <!-- Submit Update Notice Button -->
        <button
          color="primary"
          mat-icon-button
          *ngIf="hasAssignee() && isInEdit()"
          [disabled]="
            !updateNotice()?.textToBeAmended &&
            !featuresExist &&
            defaultForm?.get('aisProduct')?.value !== aisProduct.NOTAM
          "
          (click)="submitChanges()">
          <!-- !featuresExist && defaultForm?.get('aisProduct')?.value !== aisProduct.NOTAM -->
          <mat-icon>send</mat-icon>
        </button>
        <!-- Location button -->
        <!-- <button
          color="primary"
          mat-icon-button
          [disabled]="!featuresExist"
          matTooltip="Location on map"
          (click)="showMap()">
          <mat-icon>map</mat-icon>
        </button> -->
        <button
          color="primary"
          mat-icon-button
          [disabled]="!featuresExist"
          matTooltip="Location on map"
          (click)="openMapCharts()">
          <mat-icon>map</mat-icon>
        </button>
        <!-- Accept button -->
        <button
          *ngIf="isInReview() && isInReviewerRoles() && hasAssignee()"
          mat-icon-button
          matTooltip="Accept change request"
          (click)="acceptChanges()">
          <mat-icon color="primary">check</mat-icon>
        </button>
        <!-- Finish button -->
        <button
          *ngIf="updateNotice()?.status === 'task_nof_perm_notam'"
          mat-icon-button
          matTooltip="Finish"
          (click)="finishNofPermNotam()">
          <mat-icon color="primary">check</mat-icon>
        </button>
        <!-- Reject Button -->
        <button
          *ngIf="isInReview() && isInReviewerRoles() && hasAssignee()"
          mat-icon-button
          matTooltip="Reject change request"
          (click)="rejectChanges()">
          <mat-icon color="warn">block</mat-icon>
        </button>
      }
      <!-- Restore button -->
      @if (isPublishedOrCancelled()) {
        <button
          mat-icon-button
          color="primary"
          matTooltip="Restore change request"
          (click)="restoreUpdateNotice()">
          <mat-icon><span class="material-symbols-outlined">restore_from_trash</span></mat-icon>
        </button>
      }
    </div>
  </mat-toolbar>
  <div class="wrapper">
    <!-- Form Section -->
    <div
      class="form-section"
      cdkScrollable>
      <!-- Always Read-only -->
      <div class="readonly-info-wrapper">
        <div class="row items-baseline">
          <mat-form-field class="flex-1">
            <mat-label>Due date</mat-label>
            <input
              [formControl]="dueDateControl"
              matInput />
          </mat-form-field>

          <div class="flex-1 readonly-content">
            <mat-label class="status">Status</mat-label>
            <p>{{ updateNotice()?.displayedStatus }}</p>
          </div>
        </div>

        <div class="row items-baseline">
          <mat-form-field class="flex-1">
            <mat-label>Last edited on</mat-label>
            <input
              disabled
              matInput
              placeholder="Last edited"
              [value]="updateNotice()?.lastEditedDate | dateTz: 'DD MMM YYYY' | uppercase" />
          </mat-form-field>
          <div class="flex-1 readonly-content">
            <mat-label class="by">By</mat-label>
            <p>{{ updateNotice()?.userName }}</p>
          </div>
        </div>
      </div>

      <!-- Edit form -->
      <app-default-form
        mode="edit"
        [formReadonly]="formReadonly()"
        [formDisabled]="formDisabled()"
        [displayDueDateSection]="displayDueDateSection"
        [updateNoticeData]="updateNotice()"
        (aisProductChanged)="onAisProductChange($event)"
        (dueDateChanged)="onDueDateChange($event)"
        (onAttachmentClicked)="download($event)">
      </app-default-form>
    </div>

    <!-- Table Section -->
    <div class="table-section">
      <div class="search-form">
        <mat-form-field>
          <input
            matInput
            (keyup)="applyFilter($event.target.value)"
            placeholder="Filter"
            #filter />
          <mat-icon
            matSuffix
            (click)="applyFilter(''); filter.value = ''"
            style="cursor: pointer"
            >clear</mat-icon
          >
        </mat-form-field>

        <div class="search-form-btn-actions">
          <ng-container *ngIf="!loaders()?.getUpdateNotice">
            <button
              *ngIf="hasAssignee() && isInEdit()"
              class="add-feature-btn"
              mat-icon-button
              type="button"
              color="primary"
              [ngClass]="{ disable: !hasAssignee(), enable: hasAssignee() }"
              [routerLink]="[
                '/browse',
                updateNoticeId,
                updateNotice()?.name,
                updateNotice()?.effectiveDate.toISOString(),
              ]"
              matTooltip="Add Changes">
              <mat-icon>add</mat-icon>
            </button>
            @if ((defaultForm?.get("aisProduct")?.value === aisProduct.AMDT || defaultForm?.get("aisProduct")?.value === aisProduct.SUP
            || defaultForm?.get("aisProduct")?.value === aisProduct.AIC)) {
              <button
                class="add-feature-btn"
                type="button"
                [color]="showAipText() ? 'primary' : null"
                mat-icon-button
                [matTooltip]="isPublishedOrCancelled() ? '' : 'Use this only when your requested changes are not related to data from the AIS database. E.g. for runways, routes, frequencies, coordinates, etc., please use the structured data fields.'"
                (click)="toggleAipText()">
                <mat-icon>
                  <span class="material-symbols-outlined">add_notes</span>
                </mat-icon>
              </button>
            }
            <button
              *ngIf="!isPublishedOrCancelled()"
              color="primary"
              matTooltip="Validate"
              type="button"
              mat-icon-button
              (click)="navigateToValidationReport()">
              <mat-icon> <span class="material-symbols-outlined">fact_check</span> </mat-icon>
            </button>
            <button
              *ngIf="!isPublishedOrCancelled()"
              color="primary"
              matTooltip="Validation reports"
              type="button"
              mat-icon-button
              (click)="navigateToValidationHistory()">
              <mat-icon> <span class="material-symbols-outlined">library_add_check</span> </mat-icon>
            </button>
            <button
              *ngIf="hasAssignee() && isInEdit()"
              class="add-feature-btn"
              mat-icon-button
              type="button"
              color="primary"
              [ngClass]="{ disable: !hasAssignee(), enable: hasAssignee() }"
              matTooltip="Upload a Dataset"
              (click)="openDialog()">
              <mat-icon>
                <span class="material-symbols-outlined">upload</span>
              </mat-icon>
            </button>
            <button
              *ngIf="featuresExist"
              class="add-feature-btn"
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Generate dataset"
              (click)="generateDraftAISProduct()">
              <mat-icon>
                <span class="material-symbols-outlined">text_snippet</span>
              </mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="table-wrapper">
        <table
          class="features-table"
          mat-table
          [dataSource]="aixmFeatures_DataSource"
          matSort
          matSortActive="lastEdited"
          matSortDirection="asc"
          matSortDisableClear>
          <!-- Feature Type Column -->
          <ng-container matColumnDef="featureType">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header>
              Feature Type
            </th>
            <td
              mat-cell
              *matCellDef="let feature">
              <a
                [routerLink]="[
                  '/info-management',
                  feature.featureId,
                  updateNoticeId,
                  updateNotice()?.name,
                  updateNotice()?.effectiveDate?.toISOString(),
                  true,
                ]"
                [ngClass]="{
                  'not-active': feature.summary == deletion || !ableToRead(),
                  active: feature.summary != deletion && ableToRead(),
                }">
                {{ feature.featureType }}
              </a>
            </td>
          </ng-container>

          <!-- Feature Name Column -->
          <ng-container matColumnDef="featureName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header>
              Feature Name
            </th>
            <td
              mat-cell
              *matCellDef="let feature">
              <a
                [routerLink]="[
                  '/info-management',
                  feature.featureId,
                  updateNoticeId,
                  updateNotice()?.name,
                  updateNotice()?.effectiveDate?.toISOString(),
                  true,
                ]"
                [ngClass]="{
                  'not-active': feature.summary == deletion || !ableToRead(),
                  active: feature.summary != deletion && ableToRead(),
                }">
                {{ feature.featureName }}
              </a>
            </td>
          </ng-container>

          <!-- Summary Column -->
          <ng-container matColumnDef="summary">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header>
              Change Summary
            </th>
            <td
              mat-cell
              *matCellDef="let feature"
              [ngClass]="{ 'not-active': feature.summary == deletion || !hasAssignee() }">
              {{ feature.summary }}
            </td>
          </ng-container>

          <!-- Last Edited Column -->
          <ng-container matColumnDef="lastEdited">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header>
              Last Edited
            </th>
            <td
              mat-cell
              *matCellDef="let feature"
              [ngClass]="{ 'not-active': feature.summary == deletion || !hasAssignee() }">
              {{ feature.lastEdited }}
            </td>
          </ng-container>

          <!-- Delete Icon Column -->
          <ng-container matColumnDef="delete_icon">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header></th>
            <td
              mat-cell
              *matCellDef="let feature">
              <mat-icon
                *ngIf="isInEdit() && hasAssignee() && feature.summary != deletion"
                [ngClass]="{ disable: feature.summary == deletion, enable: feature.summary != deletion }"
                #delete
                (click)="openCancelDialog(feature.featureId)">
                delete
              </mat-icon>
            </td>
          </ng-container>

          <div class="search-form">
            <mat-form-field>
              <input
                matInput
                (keyup)="applyFilter($event.target.value)"
                placeholder="Filter"
                #filter />
              <mat-icon
                matSuffix
                (click)="applyFilter(''); filter.value = ''"
                style="cursor: pointer"
                >clear</mat-icon
              >
            </mat-form-field>
          </div>
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let feature"
            [ngClass]="{ 'deleted-feature-hightlight': feature.summary == deletion }"></tr>
        </table>

        <ng-container *ngIf="!aixmFeatures_DataSource.data.length || !aixmFeatures_DataSource.filteredData.length">
          <div class="no-data-wrapper">
            <mat-icon>info</mat-icon>
            <p>{{ !aixmFeatures_DataSource.data.length ? "No data yet" : "Features not found" }}</p>
          </div>
        </ng-container>
      </div>
      <mat-paginator
        #paginator
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        [showFirstLastButtons]="true">
      </mat-paginator>
      <!-- AIP Text Section -->
      @if (showAipText() && (defaultForm?.get("aisProduct")?.value === aisProduct.AMDT || defaultForm?.get("aisProduct")?.value === aisProduct.SUP
      || defaultForm?.get("aisProduct")?.value === aisProduct.AIC)) {
        <div
          class="aip-text-section"
          [formGroup]="defaultForm">
          <!-- Sections to be amended -->
          @if (defaultForm?.get("aisProduct")?.value !== aisProduct.AIC ){
          <div class="row">
            <div class="full-span">
              <mat-form-field>
                <mat-label>Section numbers to be amended</mat-label>
                <input
                  formControlName="sectionsToBeAmended"
                  type="text"
                  matInput />
                <!-- @if (defaultForm?.get('sectionsToBeAmended')?.hasError('required')){
              <mat-error>Required</mat-error>
              } -->
              </mat-form-field>
            </div>
            <button
              matTooltip="AIP sections to be amended. E.g. GEN-1.2.3."
              mat-icon-button
              color="primary">
              <mat-icon> <span class="material-symbols-filled">info_circle</span></mat-icon>
            </button>
          </div>
          <!-- Paragraph to be amended -->
          <div class="row">
            <div class="full-span">
              <mat-form-field>
                <mat-label>Paragraph numbers to be amended</mat-label>
                <input
                  formControlName="paragraphToBeAmended"
                  type="text"
                  matInput />
                <!-- @if (defaultForm?.get('paragraphToBeAmended')?.hasError('required')){
               <mat-error>Required</mat-error>
               } -->
              </mat-form-field>
            </div>
            <button
              matTooltip="Paragraph number or other reference within a section"
              mat-icon-button
              color="primary">
              <mat-icon> <span class="material-symbols-filled">info_circle</span></mat-icon>
            </button>
          </div>
         }
          <!-- Text to be amended -->
          <div class="row">
            <div class="full-span">
              <mat-form-field>
                <mat-label>
                  {{ defaultForm?.get("aisProduct")?.value === aisProduct.AIC ? "Text to be published" : "Text to be amended" }}
                </mat-label>
                <textarea
                  formControlName="textToBeAmended"
                  type="text"
                  rows="4"
                  matInput></textarea>
                <!-- @if (defaultForm?.get('textToBeAmended')?.hasError('required')){
               <mat-error>Required</mat-error>
               } -->
              </mat-form-field>
            </div>
            <button
              matTooltip="The new text to publish, including any explanation for the editors. For complex cases, please attach a PDF or other document."
              mat-icon-button
              color="primary">
              <mat-icon> <span class="material-symbols-filled">info_circle</span></mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
